export interface ApiFunctionResult<T = null> {
    data?: T;
    status?: number;
}
